import config from "@/config/env";

export const knowledgeBaseApi = {
  getDocuments: async (knowledgeBaseId: string): Promise<any> => {
    const res = await fetch(
      `${config.api.backendUrl}/api/v1/knowledge-bases/${knowledgeBaseId}/documents`
    );
    return res.json();
  },
  getDocumentStats: async (knowledgeBaseId: string): Promise<any> => {
    const res = await fetch(
      `${config.api.backendUrl}/api/v1/knowledge-bases/${knowledgeBaseId}/documents/stats`
    );
    return res.json();
  },
  searchDocuments: async (
    knowledgeBaseId: string,
    payload: { query: string; top_k?: number }
  ): Promise<any> => {
    const res = await fetch(
      `${config.api.backendUrl}/api/v1/knowledge-bases/${knowledgeBaseId}/documents/search`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );
    return res.json();
  },
  getDocumentVersions: async (documentId: string): Promise<any> => {
    const res = await fetch(`${config.api.backendUrl}/api/v1/documents/${documentId}/versions`);
    return res.json();
  },
  deleteDocument: async (documentId: string): Promise<any> => {
    const res = await fetch(`${config.api.backendUrl}/api/v1/documents/${documentId}`, {
      method: "DELETE",
    });
    return res.json().catch(() => ({}));
  },
};
